import { useSymbolsStore } from '../store/Symbols';
import { useSymbolsRender } from '../utils/useRender';
export var Arrow = props => {
  var {
    Arrow: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'Arrow');
  return null;
};
Arrow.displayName = 'JVR.Arrow';